
import { Type } from 'class-transformer';
import { PhoneNumberModel } from './PhoneNumberModel';
import { CustexAddressModel } from './CustexAddressModel';

export class CustexCustomerDetailsModel {
    public title: string = '';
    public firstName: string = '';
    public surname: string = '';

    public guid: string = '';

    @Type(() => PhoneNumberModel)
    public phoneNumbers: PhoneNumberModel[] = [];

    public allowPhoneContacts: boolean = false;
    public allowEmailContacts: boolean = false;

    @Type(() => CustexAddressModel)
    public addresses: CustexAddressModel[] = [];
}
